export default __webpack_public_path__ + "static/media/video-placeholder.c8d2c55a.png";